export const NOTES_MAX_LENGTH = 250;

export const USDOT_PATTERN = '[A-Za-z0-9]{8,10}';
export const USDOT_MAX_LENGTH = 10;
